import _ from 'lodash';
import { AT } from '../../actions/actionTypes';

import DTReducer from '../datatable/reducer';
import { resetState } from '../datatable/utils';
import { StateDefault } from './defaults';
import { State, FilterCriteria } from './model';
import { PREFIX as ORDER_PREFIX } from './actiontypes';
import Logger from '../../libs/logger';   import { LogArea } from '../../libs/logger/const';

const mapActionType = (actionType: string): string =>
  _.values(AT.ORDERS).indexOf(actionType) !== -1
    ? _.replace(actionType, ORDER_PREFIX, '')
    : '';

export default function (state = StateDefault, action: any): State {
  const dtActionType = { ...action, type: mapActionType(action.type) };
  const stateAfterDT: State = {
    ...state,
    ...DTReducer(state, dtActionType),
  };

  switch (action.type) {
    case AT.ORDERS.FILTER_CRITERIA_UPADATED: {
      Logger.info(
        [AT.ORDERS.FILTER_CRITERIA_UPADATED, action],
        LogArea.Redux
      );
      const filters: FilterCriteria = action.payload;
      return { ...stateAfterDT, ...resetState(stateAfterDT), filters };
    }

    case AT.ORDERS.TABLE_COLUMNS: {
      Logger.info([AT.ORDERS.TABLE_COLUMNS, action], LogArea.Redux);
      const table = { ...stateAfterDT.table, columns: action.payload };
      return { ...stateAfterDT, table };
    }

    case AT.ORDERS.RESET:
      Logger.info([AT.ORDERS.RESET], LogArea.Redux);
      return { ...stateAfterDT, ...resetState(stateAfterDT) };

    default: {
      return stateAfterDT;
    }
  }
}
